import AdSpace from './AdSpace';

export default AdSpace;
